export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10122.388ff8d1.jpg";